module.exports = __webpack_public_path__ + "static/media/The-Meadows-Master-Deed.dfeb4060.pdf";